<div
  [matMenuTriggerFor]="referralBadgeTooltip"
  #menuTrigger="matMenuTrigger"
  class="mat-caption"
  (mouseenter)="mouseEnter(menuTrigger)"
  (mouseleave)="mouseLeave(menuTrigger)"
>
  <span>REFERRAL</span>
</div>
<mat-menu
  #referralBadgeTooltip="matMenu"
  class="custom-menu-class"
  [hasBackdrop]="false"
  yPosition="below"
>
  <div
    (click)="$event?.stopPropagation()"
    class="referral-badge-container"
    (mouseenter)="mouseEnter(menuTrigger)"
    (mouseleave)="mouseLeave(menuTrigger)"
  >
    <ng-container *ngFor="let referral of referralList; index as i">
      <div class="referral-menu-section">
        <div class="date">{{referral?.createdDate | date:'MM.dd.yy'}}</div>
      </div>
      <div class="referral-menu-section">
        <div class="referral-menu-title">Referred by</div>
        <div>{{getNameAndEmail(referral)}}</div>
      </div>
      <div
        class="referral-menu-section"
        *ngIf="!!referral?.jobTitle"
      >
        <div class="referral-menu-title">Referred to job</div>
        <div>{{referral?.jobTitle}}</div>
      </div>
      <div class="referral-menu-section">
        <div class="referral-menu-title">Relationship</div>
        <div>{{referral?.relationShip || "-"}}</div>
      </div>
      <div class="referral-menu-section">
        <div class="referral-menu-title">Area of interest</div>
        <div>{{referral?.areaOfInterest || "-"}}</div>
      </div>
      <div class="referral-menu-section last-child">
        <div class="referral-menu-title">Endorsement</div>
        <div>{{referral?.candidateNote || "-"}}</div>
      </div>

      <div
        class="line"
        *ngIf="i < referralList?.length -1"
      >
      </div>
    </ng-container>
  </div>

</mat-menu>
